ixModuleRouting("impactx.catalog", {
    "/cataloglist/:preSetId?": {
        template: "<ixa-catalog-list></ixa-catalog-list>",
        templateUrl: "modules/catalog/templates/cataloglist.tmpl.html",
        controller: "CatalogListCtrl",
        controllerAs: "catalogListCtrl",
        process: "Catalog",
        workspace: "content",
    },
    "/internalcatalog/:id?": {
        template: "<ixa-internal-catalog></ixa-internal-catalog>",
        templateUrl: "modules/catalog/templates/internalcatalog.html",
        controller: "InternalCatalogCtrl",
        controllerAs: "catalogCtrl",
        process: "Catalog",
        workspace: "content",
    },
    "/internalcatalogsupplier/:id?": {
        template: "<ixa-internal-catalog-supplier></ixa-internal-catalog-supplier>",
        templateUrl: "modules/catalog/templates/internalcatalogsupplier.html",
        controller: "InternalCatalogSupplierCtrl",
        controllerAs: "catalogCtrl",
        process: "Catalog",
        workspace: "content",
    },
    "/externalcatalog/:id?": {
        template: "<ixa-external-catalog></ixa-external-catalog>",
        templateUrl: "modules/catalog/templates/externalcatalog.html",
        controller: "ExternalCatalogCtrl",
        controllerAs: "catalogCtrl",
        process: "Catalog",
        workspace: "content",
    },
    "/catalogapproval/:id": {
        template: "<ixa-catalog-approval></ixa-catalog-approval>",
        templateUrl: "modules/catalog/approval/templates/catalog.approval.html",
        controller: "CatalogApprovalCtrl",
        controllerAs: "catalogApprovalCtrl",
        workspace: "content",
    },
    "/catalogexport/:id/:cattrackId?": {
        template: "<ixa-catalog-export></ixa-catalog-export>",
        templateUrl: "modules/catalog/export/templates/catalog.export.html",
        controller: "CatalogExportCtrl",
        controllerAs: "catalogExportCtrl",
        process: "Catalog",
        workspace: "content",
    },
    "/cxmlcatalogexport/:usrId/": {
        template: "<ixa-cxml-catalog-export></ixa-cxml-catalog-export>",
        process: "CXMLCatalogExport",
        workspace: "admin",
    },
    "/checkedoutcataloglist/:id": {
        template: "<ixa-checked-out-catalog-list></ixa-checked-out-catalog-list>",
        templateUrl:
            "modules/catalog/templates/checkedout.catalog.product.list.html",
        controller: "CheckedOutCatalogListCtrl",
        controllerAs: "proListCtrl",
        workspace: "content",
    },
    "/checkedincataloglist/:id/:hideRules?": {
        template: "<ixa-checked-in-catalog-list></ixa-checked-in-catalog-list>",
        templateUrl:
            "modules/catalog/templates/checkedout.catalog.product.list.html",
        controller: "CheckedInCatalogListCtrl",
        controllerAs: "proListCtrl",
        workspace: "content",
    },
    "/cattracklist": {
        template: "<ixa-cat-track-list></ixa-cat-track-list>",
        templateUrl: "modules/catalog/templates/cattracklist.tmpl.html",
        controller: "CatTrackListCtrl",
        controllerAs: "catTrackListCtrl",
        process: "CatalogTrack",
        workspace: "content",
    },
    "/checkedoutcataloglist/:id/cmrlId/:cmrlId/cmrlName/:numberOfErrorItems": {
        template: "<ixa-checked-out-catalog-list></ixa-checked-out-catalog-list>",
        templateUrl:
            "modules/catalog/templates/checkedout.catalog.product.list.html",
        controller: "CheckedOutCatalogListCtrl",
        controllerAs: "proListCtrl",
        workspace: "content",
    },
    "/checkedoutcataloglist/:id/productLabelKey/:productLabelKeyValue/:numberOfItems":
        {
            template: "<ixa-checked-out-catalog-list></ixa-checked-out-catalog-list>",
            templateUrl:
                "modules/catalog/templates/checkedout.catalog.product.list.html",
            controller: "CheckedOutCatalogListCtrl",
            controllerAs: "proListCtrl",
            workspace: "content",
        },
    "/checkedincataloglist/:id/cmrlId/:cmrlId/cmrlName/:numberOfErrorItems": {
        template: "<ixa-checked-in-catalog-list></ixa-checked-in-catalog-list>",
        templateUrl:
            "modules/catalog/templates/checkedin.catalog.product.list.html",
        controller: "CheckedInCatalogListCtrl",
        controllerAs: "proListCtrl",
        workspace: "content",
    },
    "/checkedincataloglist/:id/productLabelKey/:productLabelKeyValue/:numberOfItems":
        {
            template: "<ixa-checked-in-catalog-list></ixa-checked-in-catalog-list>",
            templateUrl:
                "modules/catalog/templates/checkedin.catalog.product.list.html",
            controller: "CheckedInCatalogListCtrl",
            controllerAs: "proListCtrl",
            workspace: "content",
        },
    "/catalogrulelist/:catId": {
        template: '<ixa-catalog-rule-list></ixa-catalog-rule-list>',
        templateUrl: "modules/catalog/templates/catalogrulelist.html",
        controller: "CatalogRuleListCtrl",
        controllerAs: "catalogRuleListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogruledetail/:id/:catId": {
        template: '<ixa-catalog-rule-detail></ixa-catalog-rule-detail>',
        templateUrl: "modules/catalog/templates/catalogruledetail.html",
        controller: "CatalogRuleCtrl",
        controllerAs: "catalogRuleCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogrulechecklist/:catId": {
        template: "<ixa-catalog-rule-check-list></ixa-catalog-rule-check-list>",
        templateUrl: "modules/catalog/templates/catalogrulechecklist.html",
        controller: "CatalogRuleCheckListCtrl",
        controllerAs: "catalogRuleCheckListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogrulecheckcheckedoutitemlist/:catId": {
        template: "<ixa-catalog-rule-check-checked-out-items-list></ixa-catalog-rule-check-checked-out-items-list>",
        templateUrl:
            "modules/catalog/templates/catalogrulecheckcheckedoutitemlist.html",
        controller: "CatalogRuleCheckCheckedOutItemListCtrl",
        controllerAs: "catalogRuleCheckCheckedOutItemListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogrulecheckcheckedoutitemlist/:cmrlId/:catId": {
        template: "<ixa-catalog-rule-check-checked-out-items-list></ixa-catalog-rule-check-checked-out-items-list>",
        templateUrl:
            "modules/catalog/templates/catalogrulecheckcheckedoutitemlist.html",
        controller: "CatalogRuleCheckCheckedOutItemListCtrl",
        controllerAs: "catalogRuleCheckCheckedOutItemListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogrulecheckcheckedoutlist/:catId": {
        template:"<ixa-catalog-rule-check-checked-out-list></ixa-catalog-rule-check-checked-out-list>",
        templateUrl:
            "modules/catalog/templates/catalogrulecheckcheckedoutlist.html",
        controller: "CatalogRuleCheckCheckedOutListCtrl",
        controllerAs: "catalogRuleCheckedOutCheckListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogrulecheckitemslist/:cmrlId/:catId": {
        template: "<ixa-catalog-rule-check-item-list></ixa-catalog-rule-check-item-list>",
        templateUrl: "modules/catalog/templates/catalogrulecheckitemslist.html",
        controller: "CatalogRuleCheckItemsListCtrl",
        controllerAs: "catalogRuleCheckItemsListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogrulecheckitemdetail/:id": {
        template: "<ixa-catalog-rule-check-items-detail-list></ixa-catalog-rule-check-items-detail-list>",
        templateUrl:
            "modules/catalog/templates/catalogrulecheckitemsdetaillist.html",
        controller: "CatalogRuleCheckItemsDetailListCtrl",
        controllerAs: "catalogRuleCheckItemsDetailListCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogsystemrules": {
        template: "<ixa-catalog-rule-system></ixa-catalog-rule-system>",
        templateUrl:
            "modules/catalog/rules/templates/catalog.rule.system.list.html",
        controller: "CatalogRuleSystemListCtrl",
        controllerAs: "catalogRuleSystemListCtrl",
        process: "CatalogRuleSystem",
        workspace: "content",
    },
    "/editsystemrule/:id": {
        template: '<ixa-catalog-rule-detail></ixa-catalog-rule-detail>',
        templateUrl: "modules/catalog/templates/catalogruledetail.html",
        controller: "CatalogRuleCtrl",
        controllerAs: "catalogRuleCtrl",
        process: "CatalogRule",
        workspace: "content",
    },
    "/catalogtechnicalapproval": {
        template: "<ixa-catalog-approval-list-technical></ixa-catalog-approval-list-technical>",
        templateUrl:
            "modules/catalog/approval/templates/catalog.approval.list.html",
        controller: "CatalogApprovalListTechnicalCtrl",
        controllerAs: "catalogApprovalListCtrl",
        process: "TechnicalCatalogApproval",
        workspace: "content",
    },
    "/catalogprofessionalapproval": {
        template: "<ixa-catalog-approval-list-professional></ixa-catalog-approval-list-professional>",
        templateUrl:
            "modules/catalog/approval/templates/catalog.approval.list.html",
        controller: "CatalogApprovalListProfessionalCtrl",
        controllerAs: "catalogApprovalListCtrl",
        process: "ProfessionalCatalogApproval",
        workspace: "content",
    },
    "/catalogqualitymanagement/:id": {
        template: "<ixa-catalog-quality-management></ixa-catalog-quality-management>",
        templateUrl:
            "modules/catalog/templates/catalogqualitymanagement.tmpl.html",
        controller: "CatalogQualityManagementCtrl",
        controllerAs: "catalogQualityManagementCtrl",
        process: "Catalog",
        workspace: "content",
    },
    "/catalogarchive/:catId": {
        template: "<ixa-catalog-archive-list></ixa-catalog-archive-list>",
        templateUrl: "modules/catalog/templates/catalogarchivelist.html",
        process: "Catalog",
        controller: "CatalogArchiveListController",
        controllerAs: "catalogArchiveListController",
        workspace: "content",
    },
    "/reviewcatalog/:id": {
        template: "<ixa-review-catalog></ixa-review-catalog>",
        templateUrl: "modules/catalog/templates/reviewcatalog.html",
        process: "ReviewCatalog",
        controller: "ReviewCatalogCtrl",
        controllerAs: "reviewCatalogCtrl",
        workspace: "shop",
    },
    "/catalogreplace": {
        template: "<ixa-catalog-replace></ixa-catalog-replace>",
        templateUrl: "modules/catalog/templates/catalogreplace.html",
        process: "CatalogReplace",
        controller: "CatalogReplaceCtrl",
        controllerAs: "catalogReplaceCtrl",
        workspace: "content",
    },
    "/catalogeditorold/:id?": {
        template: "<ixa-catalog-editor></ixa-catalog-editor>",
        process: "Catalog",
        workspace: "content",
    },
    /* Reworked catalog editor => set as default for now, but keep old version around as backup */
    "/catalogeditorlist": {
        template: "<ixa-catalog-editor-list></ixa-catalog-editor-list>",
        process: "Catalog",
        workspace: "content",
    },
    "/catalogeditor/:id": {
        template: "<ixa-catalog-editor-v2></ixa-catalog-editor-v2>",
        process: "Catalog",
        workspace: "content",
    },

    "/metacatalogeditor": {
        template: "<ixa-meta-catalog-editor></ixa-meta-catalog-editor>",
        process: "Catalog",
        workspace: "content",
    },
    "/copycatalogtoview/:baseCatalogId": {
        template: "<ixa-copy-catalog-to-view></ixa-copy-catalog-to-view>",
        process: "CopyCatalogToView",
        workspace: "content",
    },
    "/pricegrouplist": {
        template: "<ixa-pricegroup-list></ixa-pricegroup-list>",
        process: "PriceGroup",
        workspace: "content",
    },
    "/pricegroup/:id": {
        template: "<ixa-pricegroup-dialog></ixa-pricegroup-dialog>",
        process: "PriceGroup",
        workspace: "content",
    }
});
